import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  reservations : [],
  customerReservations : [],
  selectedReservation : null,
  selectedIndex : null,
  orderBy:{orderName : 'created_at',  direction:'DESC'},
  outDated : true,
  mode : 'tile',
  loading : false,
  searchTerms :'',
  sort_icon : 'el-icon-caret-bottom',
  icons : {
    'DESC' : 'el-icon-caret-bottom',
    'ASC' : 'el-icon-caret-top'
  },
  page : 1,
  pages : 0, //nombre de page total
  count : 0,
  limit : 100,
  activeTab : 'overview',
  filters : {
    inactive : false,
    active : true,//Par défaut on affiche seulement les réservations actives
    intent: true,
    completed: false,
    redFlag : false,
    yellowFlag : false,
    greenFlag : false,
    salesRep : [],
    delayed : true,
    customerId : null,
    productId : null,
    inventories : [],
    checkedCustomerClasses : [],
  }

});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
